import { logger } from '../../utils/logger';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import '../app/app.css';

interface PrivateRouteProps {
    children: React.ReactNode;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();

    logger.log('PrivateRoute state:', { isAuthenticated, loading });

    if (loading) {
        logger.log('PrivateRoute: Loading state, showing loading indicator');
        return (
            <div className="gt-app">
                <div className="gt-page" role="status" aria-live="polite">
                    <span className="visually-hidden">Loading your account…</span>
                    <div className="gt-skeleton" aria-hidden="true"><span /><span /><span /></div>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        logger.log('PrivateRoute: Not authenticated, redirecting to login');
        return <Navigate to="/login" />;
    }

    logger.log('PrivateRoute: Authenticated, rendering protected content');
    // .gt-app scopes the Hallmark app styles (components/app/app.css) to signed-in screens
    return <div className="gt-app">{children}</div>;
}; 